module.exports = __webpack_public_path__ + "img/image_33.585da3f6.png";